import React, { Component } from 'react';
import { MainLayout } from './layouts/MainLayout';
import { AdminLayout } from './layouts/AdminLayout';
import { Dashboard } from './pages/Dashboard';
import { Clienti } from './pages/Clienti';
import { PianiRientro } from './pages/PianiRientro';
import { CessioneCredito } from './pages/CessioneCredito';
import { Legal } from './pages/Legal';
import { Impostazioni } from './pages/Impostazioni';
import { ImpostazioniUtente } from './pages/ImpostazioniUtente';
import { Corrispondenza } from './pages/Corrispondenza';
import { Automazioni } from './pages/Automazioni';
import { Scadenze } from './pages/Scadenze';
import { Report } from './pages/Report';
import { Login } from './pages/Login';
import { AdminClienti } from './pages/admin/AdminClienti';
import { UtentiNonAttivi } from './pages/admin/UtentiNonAttivi';
import { PraticheIncagliate } from './pages/admin/PraticheIncagliate';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// Componente per proteggere le rotte
function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAuthenticated
  } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-0" />;
  }
  return <>{children}</>;
}
// Componente per il routing principale
function AppRoutes() {
  return <Routes data-id="element-1">
      <Route path="/login" element={<Login data-id="element-3" />} data-id="element-2" />
      {/* Client Routes */}
      <Route path="/" element={<ProtectedRoute data-id="element-5">
            <MainLayout data-id="element-6">
              <Dashboard data-id="element-7" />
            </MainLayout>
          </ProtectedRoute>} data-id="element-4" />
      <Route path="/clienti" element={<ProtectedRoute data-id="element-9">
            <MainLayout data-id="element-10">
              <Clienti data-id="element-11" />
            </MainLayout>
          </ProtectedRoute>} data-id="element-8" />
      <Route path="/piani-rientro" element={<ProtectedRoute data-id="element-13">
            <MainLayout data-id="element-14">
              <PianiRientro data-id="element-15" />
            </MainLayout>
          </ProtectedRoute>} data-id="element-12" />
      <Route path="/cessione-credito" element={<ProtectedRoute data-id="element-17">
            <MainLayout data-id="element-18">
              <CessioneCredito data-id="element-19" />
            </MainLayout>
          </ProtectedRoute>} data-id="element-16" />
      <Route path="/legal" element={<ProtectedRoute data-id="element-21">
            <MainLayout data-id="element-22">
              <Legal data-id="element-23" />
            </MainLayout>
          </ProtectedRoute>} data-id="element-20" />
      <Route path="/corrispondenza" element={<ProtectedRoute data-id="element-25">
            <MainLayout data-id="element-26">
              <Corrispondenza data-id="element-27" />
            </MainLayout>
          </ProtectedRoute>} data-id="element-24" />
      <Route path="/automazioni" element={<ProtectedRoute data-id="element-29">
            <MainLayout data-id="element-30">
              <Automazioni data-id="element-31" />
            </MainLayout>
          </ProtectedRoute>} data-id="element-28" />
      <Route path="/scadenze" element={<ProtectedRoute data-id="element-33">
            <MainLayout data-id="element-34">
              <Scadenze data-id="element-35" />
            </MainLayout>
          </ProtectedRoute>} data-id="element-32" />
      <Route path="/report" element={<ProtectedRoute data-id="element-37">
            <MainLayout data-id="element-38">
              <Report data-id="element-39" />
            </MainLayout>
          </ProtectedRoute>} data-id="element-36" />
      <Route path="/impostazioni" element={<ProtectedRoute data-id="element-41">
            <MainLayout data-id="element-42">
              <Impostazioni data-id="element-43" />
            </MainLayout>
          </ProtectedRoute>} data-id="element-40" />
      <Route path="/impostazioni-utente" element={<ProtectedRoute data-id="element-45">
            <MainLayout data-id="element-46">
              <ImpostazioniUtente data-id="element-47" />
            </MainLayout>
          </ProtectedRoute>} data-id="element-44" />
      {/* Admin Routes */}
      <Route path="/admin" element={<ProtectedRoute data-id="element-49">
            <AdminLayout data-id="element-50">
              <Dashboard data-id="element-51" />
            </AdminLayout>
          </ProtectedRoute>} data-id="element-48" />
      <Route path="/admin/clienti" element={<ProtectedRoute data-id="element-53">
            <AdminLayout data-id="element-54">
              <AdminClienti data-id="element-55" />
            </AdminLayout>
          </ProtectedRoute>} data-id="element-52" />
      <Route path="/admin/utenti-non-attivi" element={<ProtectedRoute data-id="element-57">
            <AdminLayout data-id="element-58">
              <UtentiNonAttivi data-id="element-59" />
            </AdminLayout>
          </ProtectedRoute>} data-id="element-56" />
      <Route path="/admin/pratiche-incagliate" element={<ProtectedRoute data-id="element-61">
            <AdminLayout data-id="element-62">
              <PraticheIncagliate data-id="element-63" />
            </AdminLayout>
          </ProtectedRoute>} data-id="element-60" />
      <Route path="*" element={<Navigate to="/" replace data-id="element-65" />} data-id="element-64" />
    </Routes>;
}
export function App() {
  return <BrowserRouter data-id="element-66">
      <AuthProvider data-id="element-67">
        <AppRoutes data-id="element-68" />
      </AuthProvider>
    </BrowserRouter>;
}